import { useEffect, useRef, useState } from 'react';
import { useGameStore } from '../store';

export function MDisplay() {
  const mBalance = useGameStore((state) => state.mBalance);
  const prevBalanceRef = useRef(mBalance);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    // Check if balance changed (skip initial render)
    if (prevBalanceRef.current !== mBalance) {
      setIsAnimating(true);

      // Remove animation class after 300ms
      const timer = setTimeout(() => {
        setIsAnimating(false);
      }, 300);

      prevBalanceRef.current = mBalance;
      return () => clearTimeout(timer);
    }
  }, [mBalance]);

  return (
    <div
      className={`
        font-pixel text-base sm:text-lg text-gold
        transition-transform duration-300 ease-out
        ${isAnimating ? 'scale-125' : 'scale-100'}
      `}
    >
      M: {mBalance}
    </div>
  );
}
